module.exports = __webpack_public_path__ + "static/media/notification.d2dc1bd8.svg";